import { today, yesterday } from  '@/helpers/Dates';

export interface IBreakdown {
    image:string,
    number:number,
    label:string
    ref:string,
    contentType?:InsightsContentType
}

export enum InsightsContentType
{
    View = 0,
    Like = 1,
    Comment = 2,
    Ugc = 3,
    Recognition = 4,
    Share = 5,
    Event = 6,
    Competition = 7,
    Compliance = 8,
    Mp3 = 9,
    Video = 10,
    File = 11,
    UniqueView = 12,
}

export interface IBreakdownCompare {
    image:string,
    percent:number,
    day1No:number,
    day2No:number,
    label:string
    ref:string,
    direction:NumberDirection
}

export interface IDirectionStats {
    leaderBoardPosition:number,
    positionsMoved:number,
    direction:NumberDirection
}

export enum NumberDirection {
    up = "up",
    down = "down",
    neutral = "neutral",
    na = "na",
    new = "new"
}

export interface OrderBy {
    column:string,
    direction: Direction
}

export enum Direction {
   asc = "Ascending",
   dsc = "Descending"
}

export interface IUserDevices {
    usersRegistered:number,
    userLoggedIn:number,
    ios:number,
    android:number,
    web:number,
    csvDownload:string
}

export interface IWorkspace {
    id:number,
    title:string
}

export enum Toggle {
    date1 = "date1",
    date2 = "date2"
}

export interface IExistingItem {
    id:number,
    title:string,
    contenttype:string,
    contentTypeLabel?:string,
    thumbnail:string
}

export enum FilterPage {
    content = "Content",
    users = "Users"
}

export interface IOption {
    value:string,
    label:string
}

export const InitIWorkspace = {
    id:0,
    title:""
}

export const initUserDevices:IUserDevices = {
    usersRegistered:0,
    userLoggedIn:0,
    ios:0,
    android:0,
    web:0,
    csvDownload: ""
}

export const initBreakdown:IBreakdown[] = [];

export enum BreakdownType {
    default = "Default",
    compare = "Compare"
}

export interface IDateRange {
    dateFrom:Date, 
    dateTo:Date,
    label?:string
}

export interface ISearchFilter {
    date1:IDateRange,
    date2:IDateRange,
    selectedWorkspace:IOption,
    selectedUserGroups:IOption[],
    existingItem:IExistingItem[]
}

export const InitSearchFilter:ISearchFilter = {
    date1:{ dateFrom:today().dateFrom, dateTo:today().dateTo, label:"Today" },
    date2:{ dateFrom:yesterday().dateFrom, dateTo:yesterday().dateTo, label:"Yesterday" },
    selectedWorkspace:null,
    selectedUserGroups:[],
    existingItem:null
}

export interface IAggregated {
    insightsChannelPopularityResource:any,
    insightsContentPopularityResource:any,
    insightsListPopularityResource:any,
    insightsUserGroupActivityResource:any,
    insightsUsersAndDevicesResource:any,
    insightsWorkspaceInsightsResource:any
}

export interface IReport {
    name:string,
    url:string
}

export interface ITooltipData {
    contentPop: string,
    contentPopOverview:string,
    userGroupsLoginOverview:string,
    download: string,
    userGroup:string,
    listPop: string,
    channelAct: string,
    insightsOverall:string
}

export interface ILoadTracker {
    setLoadMin: (value:number) => void,
    dispatch:React.Dispatch<any>
}